import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
// @mui
import { styled } from '@mui/material/styles';
import { Box, Link, Typography } from '@mui/material';
// hooks

// routes
import { PATH_DASHBOARD } from '../../../routes/paths';
// components
import MyAvatar from '../../../components/MyAvatar';
import Iconify from '../../../components/Iconify';


// ----------------------------------------------------------------------

const RootStyle = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(2, 2.5),
  borderRadius: Number(theme.shape.borderRadius) * 1.5,
  backgroundColor: theme.palette.primary.main,
  transition: theme.transitions.create('opacity', {
    duration: theme.transitions.duration.shorter,
  }),
}));

// ----------------------------------------------------------------------

NavbarDonate.propTypes = {
  isCollapse: PropTypes.bool,
};



export default function NavbarDonate({ isCollapse }) {
  const user = localStorage.getItem("userEmail");
  
  return (
    <Link underline="none" color="inherit" component={RouterLink} to={PATH_DASHBOARD.general.donate}>
      <RootStyle
        sx={{
          ...(isCollapse && {
            bgcolor: 'transparent',
          }),
        }}
      >
        {user &&
        <MyAvatar /> 
        }
        <Box
          sx={{
            ml: 2,
            transition: (theme) =>
              theme.transitions.create('width', {
                duration: theme.transitions.duration.shorter,
              }),
            ...(isCollapse && {
              ml: 0,
              width: 0,
            }),
          } }
          
        >
          <Typography variant="subtitle2" color= "white" >
            Donate     <Iconify  icon={'bxs:donate-heart'}  sx={{color:'white', alignItems:'flex-end', ml:10}}/>
          </Typography>
        
          
          
         
          
                   
        </Box>
        
        
      </RootStyle>
      
    </Link>
  );
}
